import { Component, OnInit } from '@angular/core';
import { ValidationError, FormValidator, ErrorHandlingService, FormValidationService } from 'core-lib';
import { ForgotPasswordService, ValidatePasswordResetResponseData } from '../services/forgot-password.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'cli-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  public vm: ResetPasswordViewModel;
  private validator: FormValidator;

  constructor(private route: ActivatedRoute,
    private forgotPwdSvc: ForgotPasswordService,
    private errorHandlingSvc: ErrorHandlingService,
    private formValidationSvc: FormValidationService) {

    this.vm = new ResetPasswordViewModel();
    this.validator = formValidationSvc.getFormValidator(this.vm);

    this.vm.isOpening = true;
  }

  ngOnInit() {
    let activationCode: string = this.route.snapshot.paramMap.get('id');
    let username: string = this.route.snapshot.queryParamMap.get('username');

    this.vm.activationCode = activationCode;
    this.vm.userName = username;

    this.forgotPwdSvc.validateResetPassword(activationCode, username).toPromise()
      .then((data: ValidatePasswordResetResponseData) => {
        this.vm.isValidated = data.exists;
      }, () => { })
      .finally(() => { this.vm.isOpening = false; });
  }

  public validate(vm: ResetPasswordViewModel): Promise<void> {
    vm.errors = [];

    let specified1 = this.validator.validateRequired('password', 'Password');
    let specified2 = this.validator.validateRequired('confirmPassword', 'Password');

    this.validator.validateMinLength('password', 'Password', 6);
    this.validator.validateMinLength('confirmPassword', 'Password', 6);

    if (specified1 && specified2) {
      this.validator.validateCustom('confirmPassword', 'Passwords do not match', () => {
        return vm.password !== vm.confirmPassword;
      });

    }

    if (vm.errors.length > 0) { return Promise.reject('Invalid input'); }

    return Promise.resolve();
  }


  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }

  public submit(): Promise<void> {
    return this.validate(this.vm)
      .then(() => {
        this.vm.isLoading = true;

        return this.forgotPwdSvc.resetPassword(this.vm.activationCode,
          this.vm.userName,
          this.vm.password).toPromise().then(() => { 

            this.vm.isSubmitted = true;
          },
            () => { }).finally(() => {

              this.vm.isLoading = false;
            });
      }, () => { });
  }

}

export class ResetPasswordViewModel {

  constructor() {
    this.errors = [];
  }

  public isOpening: boolean;
  public isLoading: boolean;
  public isSubmitted: boolean;
  public isValidated: boolean;

  public password: string;
  public confirmPassword: string;
  public userName: string;
  public activationCode: string;

  public errors: ValidationError[];
}
